import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Registration from './views/Auth/Registration.vue';
import Politic from './views/About/Politic.vue';
import PersonData from './views/About/PersonData.vue';
import Manager from './views/Manager.vue';
import ManagerComplaints from './views/Manager/Complaints/Complaints.vue';
import ManagerArchive from './views/Manager/Complaints/Archive.vue';
import ClientComplaints from './views/Client/Complaints/Complaints.vue';
import ClientArchive from './views/Client/Complaints/Archive.vue';
import ResetPassword from './views/Auth/ResetPassword.vue';
Vue.use(Router);
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/', name: 'home', component: Home, meta: { requiresAuth: false },
        },
        {
            path: '/registration', name: 'registration', component: Registration, meta: { requiresAuth: false },
        },
        {
            path: '/forgot', name: 'forgot', component: ResetPassword, meta: { requiresAuth: false },
        },
        {
            path: '/politic', name: 'politic', component: Politic, meta: { requiresAuth: false },
        },
        {
            path: '/person-data', name: 'person_data', component: PersonData, meta: { requiresAuth: false },
        },
        {
            path: '/manager', name: 'manager', component: Manager, meta: { requiresAuth: true },
            children: [
                {
                    path: '/manager/complaints',
                    name: 'manager-complaints',
                    component: ManagerComplaints,
                    meta: { requiresAuth: true },
                },
                {
                    path: '/manager/archive',
                    name: 'manager-archive',
                    component: ManagerArchive,
                    meta: { requiresAuth: true },
                },
                {
                    path: '/client/complaints',
                    name: 'manager-client-complaints',
                    component: ClientComplaints,
                    meta: { requiresAuth: true },
                },
                {
                    path: '/client/archive',
                    name: 'manager-client-archive',
                    component: ClientArchive,
                    meta: { requiresAuth: true },
                },
            ],
        },
    ],
});
//# sourceMappingURL=router.js.map